import React, { useContext, useState, useEffect } from 'react';
import { MdCloudUpload } from 'react-icons/md';

import { AppContext } from '../context/GlobalContext';

import { getPalette } from '../helpers/palette';
import { addEvent, getImageHTML } from '../helpers/functions';

const FileUploadUI = () => {
  let { setImage, globalState, setColors } = useContext(AppContext);
  let { image } = globalState;

  let [url, setURL] = useState(image ? image : '');

  useEffect(() => {
    setURL(image);
  }, [image]);

  function FileDragHover(e) {
    e.stopPropagation();
    e.preventDefault();
  }

  const FileSelectHandler = (e) => {
    // cancel event and hover styling
    FileDragHover(e);

    // fetch FileList object
    var files = e.target.files || e.dataTransfer.files;

    // process all File objects
    for (var i = 0, f; (f = files[i]); i++) {
      if (f.type.substring(0, 5) !== 'image') {
        console.log('Unsupported file type: ' + f.name);
      } else {
        loadImage(f);
      }
    }
  };

  function loadImage(image) {
    var fr = new FileReader();
    fr.onload = function (e) {
      var imageHTML = getImageHTML(e.target.result);

      var img = imageHTML.getElementsByTagName('img')[0];

      // Must wait for image to load in DOM, not just load from FileReader
      addEvent(img, 'load', function () {
        setColors(getPalette(img));
        setImage(img.getAttribute('src'));
      });
    };
    fr.readAsDataURL(image);
  }
  return (
    <div className='file-upload'>
      <div className='file-upload__modal'>
        <div className='file-upload__modal--head'>
          <p>Upload Image</p>
        </div>
        <div className='file-upload__modal--body'>
          <div
            className='file-upload__modal--body-image-contianer'
            onDrop={FileSelectHandler}
            onDragOver={FileDragHover}
            onDragLeave={FileDragHover}
          >
            {url ? (
              <img
                src={url}
                alt=''
                className='file-upload__modal--body-image-contianer-img'
              />
            ) : (
              <>
                <div className='file-upload__modal--body-image-contianer-icon'>
                  <MdCloudUpload style={{ fontSize: 70, marginTop: 10 }} />
                </div>
                <div className='file-upload__modal--body-image-contianer-desc'>
                  <h4>Drag and Drop to Upload Image</h4>
                  <p>
                    or{' '}
                    <label
                      htmlFor='file-select-input'
                      className='file-upload__modal--body-image-contianer-label'
                    >
                      {' '}
                      browse{' '}
                    </label>
                    <input
                      type='file'
                      id='file-select-input'
                      name='fileselect[]'
                      multiple='multiple'
                      className='file-upload__modal--body-image-contianer-input'
                      onChange={FileSelectHandler}
                    />
                    to choose a file
                  </p>
                </div>
                <div className='file-upload__modal--body-image-contianer-footer'>
                  <p>(comaptible with JPG, JPEG, PNG)</p>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileUploadUI;
